import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AwaitingContactComponent } from './awaiting-contact/awaiting-contact.component';
import { CompanySetupCheckoutComponent } from './company-setup-checkout/company-setup-checkout.component';
import { CompanySetupWaitingComponent } from './company-setup-waiting/company-setup-waiting.component';
import { CompanySetupComponent } from './company-setup.component';

const routes: Routes = [
  {
    path: '',
    component: CompanySetupComponent,
  },
  {
    path: 'waiting',
    component: CompanySetupWaitingComponent,
  },
  {
    path: 'awaiting-contact',
    component: AwaitingContactComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CompanySetupRoutingModule {}
